import { render, staticRenderFns } from "./AccRecvPreview.vue?vue&type=template&id=b04d39ee&"
import script from "./AccRecvPreview.vue?vue&type=script&lang=js&"
export * from "./AccRecvPreview.vue?vue&type=script&lang=js&"
import style0 from "./AccRecvPreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports